import SidePanelSelector from "./SidePanelSelector";

export default SidePanelSelector;
